import { TItems } from '@/types/invoice';

type ItemInput = Pick<TItems, 'total' | 'tax'>;

export const calculateInvoiceTotals = (items: ItemInput[]) => {
  const subtotal = items.reduce((sum, item) => sum + Number(item.total), 0);
  const tax = items.reduce(
    (sum, item) => sum + (Number(item.total) * Number(item.tax)) / 100,
    0
  );

  return {
    subtotal,
    tax,
    total: subtotal + tax,
  };
};
